import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'

export default function InfoCircleIcon(props) {
    const { style } = props;
    const classes = useStyles(props)()

    return(
        <svg className={classes.container} style={style} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 0C3.129 0 0 3.1367 0 7C0 10.8647 3.129 14 7 14C10.864 14 14 10.8647 14 7C14 3.1367 10.864 0 7 0ZM7 9.0517C7.336 9.0517 7.609 9.3247 7.609 9.6607C7.609 9.9967 7.336 10.2767 6.993 10.2767C6.657 10.2767 6.384 9.9967 6.384 9.6607C6.384 9.3247 6.657 9.0517 7 9.0517ZM7 3.731C7.336 3.731 7.616 4.0117 7.616 4.347V7.441C7.616 7.7777 7.336 8.05 7 8.05C6.664 8.05 6.391 7.7777 6.391 7.441V4.347C6.391 4.0117 6.664 3.731 7 3.731Z" fill="#2196C0"/>
        </svg>

    )
}


const useStyles = props => makeStyles((theme) => ({
    container:{
        '& path': {
            fill: props.color,
            width: props.width,
         },
    }
}));